import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "defaultTo" })
export class DefaultToPipe implements PipeTransform {
  transform<V, D>(value: V, defaultValue: NonNullable<D>) {
    return value ? value : defaultValue;
  }
}
